export default __webpack_public_path__ + "static/media/card1.6b7e3694.svg";